import { Flex } from '@/components/ui/flex'
import { DirtyFieldChange } from '@/hooks'
import { Building } from '@/reducers/types'

import { IS_PAY_RENT_ENABLED } from '../../../places.gates'
import { getBuildingPms } from '../../../places.pms'
import { ConnectedPms } from './connected-pms'
import { isPayRentAvailable } from './pay-rent/pay-rent.utils'
import { PayRentCard } from './pay-rent/pay-rent-card'
import { PmsConnectForm } from './pms-connect-form'

interface PmsTabProps {
  building: Building
  isAdmin: boolean
  onDirtyChange: (isDirty: boolean, getChanges?: () => DirtyFieldChange[]) => void
}

export const PmsTab = ({ building, isAdmin, onDirtyChange }: PmsTabProps) => {
  const provider = getBuildingPms(building)

  if (!provider) return <PmsConnectForm building={building} />

  // Note: payment settings are Administrator-only on the backend
  const showPayRent = IS_PAY_RENT_ENABLED && isAdmin && isPayRentAvailable(building, provider)

  return (
    <Flex direction="column" gap={16}>
      <ConnectedPms building={building} provider={provider} />
      {showPayRent && (
        <PayRentCard building={building} provider={provider} onDirtyChange={onDirtyChange} />
      )}
    </Flex>
  )
}
